import { type SVGProps } from "react";

export function RequestIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66667 7.49992H13.3333M6.66667 10.8333H11.6667M11.6667 14.9999H10.8333L6.66667 17.4999V14.9999H5C4.33696 14.9999 3.70107 14.7365 3.23223 14.2677C2.76339 13.7988 2.5 13.163 2.5 12.4999V5.83325C2.5 5.17021 2.76339 4.53433 3.23223 4.06549C3.70107 3.59664 4.33696 3.33325 5 3.33325H15C15.663 3.33325 16.2989 3.59664 16.7678 4.06549C17.2366 4.53433 17.5 5.17021 17.5 5.83325V9.58325M15.8333 18.3333V18.3416M15.8333 15.8333C16.2069 15.8321 16.5693 15.7056 16.8625 15.474C17.1557 15.2425 17.3627 14.9193 17.4505 14.5562C17.5382 14.1931 17.5016 13.811 17.3465 13.4711C17.1914 13.1313 16.9268 12.8533 16.595 12.6816C16.2635 12.5118 15.8843 12.4591 15.519 12.5322C15.1538 12.6053 14.824 12.7998 14.5833 13.0841"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
